import { Address } from "@msuite/ui/address";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { StateTag } from "@msuite/ui/tag";
import { getAddressString } from "@msuite/utils/strings";
import type { OrganizationPartnership } from "@msuite/utils/types";
import { OrganizationCard } from "@/components/cards";
import { PartnerRoleCell } from "./partner-role-cell";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<OrganizationPartnership>();

export const columns = [
	columnHelper.accessor((row) => row._partner.name, {
		id: "partnerName",
		header: "Name",
		cell: (cell) => <OrganizationCard orgId={cell.row.original._partner.id} />,
	}),
	columnHelper.accessor((row) => getAddressString(row._partner), {
		id: "address",
		header: localized("address.address"),
		cell: (cell) => <Address item={cell.row.original._partner} />,
	}),
	columnHelper.display({
		id: "role",
		header: localized("partners.role"),
		cell: (cell) => <PartnerRoleCell partnership={cell.row.original} />,
	}),
	columnHelper.accessor("state", {
		id: "name",
		header: localized("general.state"),
		cell: (cell) => <StateTag state={cell.getValue()} />,
	}),
	columnHelper.display({
		id: "actions",
		header: "",
		cell: (cell) => <RowActions partner={cell.row.original} />,
		enableSorting: false,
		enableHiding: false,
		enablePinning: false,
	}),
];
